import { Group } from "@entities";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { heIL } from "@mui/x-date-pickers/locales";
import { type HyperTableFilter } from "@shared/frontend/hyper-table";
import dayjs, { type Dayjs } from "dayjs";

const filters: HyperTableFilter<Group>[] = [
  { fieldName: "name", id: "name" },
  { fieldName: "description", id: "description" },
  { fieldName: "comments", id: "comments" },
  {
    id: "teams",
    icon: "date",
    caption: "מגיעות בתאריך",
    renderFilter: ({ onSave, meta }) => {
      const dayjsValue =
        typeof meta.value === "string"
          ? dayjs(new Date(meta.value))
          : meta.value;
      return (
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          localeText={
            heIL.components.MuiLocalizationProvider.defaultProps.localeText
          }
          adapterLocale="he"
        >
          <DateCalendar
            // SlotProps={{
            //     leftArrowIcon: { sx: { transform: "rotate(180deg)" } },
            //     rightArrowIcon: { sx: { transform: "rotate(180deg)" } }
            // }}
            value={dayjsValue as Dayjs & { $d: Date }}
            onChange={(value) => {
              onSave({
                value: Group.filterGroupsByEventDate({ date: value }),
                meta: {
                  value,
                },
              });
            }}
          />
        </LocalizationProvider>
      );
    },
  },
];

export default filters;
